import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var FormGroupStyles = styled.fieldset(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), function (_ref) {
  var $condensed = _ref.$condensed,
    theme = _ref.theme;
  return theme.sizing[$condensed ? 'tiny' : 'small'];
});
var Root = FormGroupStyles;

export { Root as default };
//# sourceMappingURL=FormGroup.styles.js.map
